import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class refundView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Refund View Error Message';
  _message = 'Refund View Success Message';

  _generateMarkup() {
    return `
      <div class="row refund">
        <h1 class="heading__static">Cancelation & Refund Policy</h1>
        <h2 class="heading__static heading__static--sub">Cancelation policy</h2>
        <p class="paragraph">
          You can cancel any order before making the payment for purchase.
        </p>

        <h2 class="heading__static heading__static--sub">Refund policy</h2>
        <p class="paragraph">
          We do not provide any sort of refunds after the product is been sold
          to customer, which you acknowledge prior to purchasing any product on
          the Website. Please make sure that you've carefully read service
          description before making a purchase. Once any sort of payments is
          been made for any product is non-Refundable.
          <a href="/terms" style="text-decoration: none; color: #0066fb"
            >Read more...</a
          >
        </p>
        <h2 class="heading__static heading__static--sub">
          Failed Payment / Payment Deducted
        </h2>
        <p class="paragraph">
          Incase of amount is deducted from your account but
          course/membership/product is not updated then :
        </p>
        <ol style="list-style: none">
          <li class="paragraph">
            1. <a href="/contact" class="link"> Contact us</a> we will check if
            payment is received then we will update the course from backend
          </li>
          <li class="paragraph">
            2. If payment is not received to us then you will have to wait bank
            will refund in your account in 2-7 days
          </li>
        </ol>
      </div>
    `;
  }
}

export default new refundView();
